import { HttpInterceptorFn } from '@angular/common/http';
import { inject, makeStateKey, TransferState, PLATFORM_ID, REQUEST_CONTEXT } from '@angular/core';
import { isPlatformServer } from '@angular/common';

const STATE_KEY = makeStateKey<string>('USER_STATE');

export const apiStateInterceptor: HttpInterceptorFn = (req, next) => {
  const transferState = inject(TransferState);
  const platformId = inject(PLATFORM_ID);
  
  let userState = 'default';

  // Phase 1: Are we running on the Server?
  if (isPlatformServer(platformId)) {
    // Read the custom context we passed from server.ts
    const serverContext = inject(REQUEST_CONTEXT, { optional: true }) as { userState?: string } | null;
    
    if (serverContext && serverContext.userState) {
      userState = serverContext.userState;
      
      // Save it so the browser can find it later
      transferState.set(STATE_KEY, userState);
    }
  } 
  // Phase 2: Are we running in the Browser?
  else {
    userState = transferState.get(STATE_KEY, 'default');
  }

  // Phase 3: Attach it to the outgoing API request to Laravel
  const modifiedReq = req.clone({
    setHeaders: {
      'X-User-State': userState
    }
  });

  return next(modifiedReq);
};